import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Row, Col, Form, Input, DatePicker } from 'antd';
import moment from 'moment'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
const { RangePicker } = DatePicker;
const { TextArea } = Input;
@inject('reportStore','uiState')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef();
  componentDidMount() {
    const { reportStore } = this.props
    this.formRef.current.setFieldsValue({
      partnerNumber: 2000726692
    })
    reportStore.onChangeEBillingList([])
    reportStore.onChangeSelectedRowKeys([],[])
  }
  handleSearch=()=>{
    const { reportStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        partnerNumber: parseInt(fieldsValue.partnerNumber),
        customerPos: fieldsValue.customerPos!==undefined&&fieldsValue.customerPos?.length>0?fieldsValue.customerPos?.split(","):[],
        billingNos: fieldsValue.billingNos!==undefined&&fieldsValue.billingNos?.length>0?fieldsValue.billingNos?.split(","):[],
        createDateBegin: !fieldsValue.billingDate[0] ?'':moment(fieldsValue.billingDate[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        createDateEnd: !fieldsValue.billingDate[1] ?'':moment(fieldsValue.billingDate[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      reportStore.onSearchEBillingAction(params,1,PAGE_SIZE_DEFAULT)
      reportStore.onChangeSelectedRowKeys([],[])
    }).catch(err => {
    })
  }
  handleResend=()=>{
    const { reportStore } = this.props
    const { selectedRows } = reportStore
    const params= []
    selectedRows.map(item=> {return params.push(item.requestId)})
    reportStore.onResendAction({requestIds:params}).then(res=>{
      if (res.data.code === 200) {
        reportStore.onChangeSelectedRowKeys([],[])
      }
    })
  }
  handleExport=()=>{
    const { uiState } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        partnerNumber: parseInt(fieldsValue.partnerNumber),
        customerPos: fieldsValue.customerPos!==undefined&&fieldsValue.customerPos?.length>0?fieldsValue.customerPos?.split(","):[],
        billingNos: fieldsValue.billingNos!==undefined&&fieldsValue.billingNos?.length>0?fieldsValue.billingNos?.split(","):[],
        createDateBegin: !fieldsValue.billingDate[0] ?'':moment(fieldsValue.billingDate[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        createDateEnd: !fieldsValue.billingDate[1] ?'':moment(fieldsValue.billingDate[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      uiState.onChangeFetchingExport('/open/api/v1/billing/report/export', params, `E-Billing_Report.xlsx`)
    }).catch(err => {
    })
  }
  render() {
    const formItemLayout = {
      labelCol: { span: 10},
      wrapperCol: { span: 14 },
    }
    const checkMaxLength=(rule,value,callback)=>{
      if(value!==undefined&&value.length>1000){
        callback('The input content has exceeded 1000 characters！')
      }else {
        callback()
      }
    }
    return (
      <>
        <Form ref={this.formRef} initialValues={{}}>
          <Row>
            <Col span={6}>
              <Form.Item name='partnerNumber' label='Partner Number' {...formItemLayout}
                         rules={[{ required:true, message: 'Please enter Partner Number without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                <Input placeholder="Please enter ..." disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='billingDate' label='Billing Date' labelCol={{span:8}} wrapperCol={{span: 16}} rules={[{ required:true, message: 'Please enter Billing Date.'}]}>
                <RangePicker
                  allowClear
                  format="YYYY-MM-DD"
                  key='RangePicker'
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='customerPos' label='Customer Po' labelCol={{span:9}} wrapperCol={{span: 15}}
                         rules={[{ message: 'Please enter Customer Po without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) },{ validator: checkMaxLength}]}>
                <TextArea rows={1} placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='billingNos' label='Billing No' labelCol={{span:8}} wrapperCol={{span: 16}}
                         rules={[{ message: 'Please enter Billing No without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) },{ validator: checkMaxLength}]}>
                <TextArea rows={1} placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={24}style={{textAlign: 'right', marginTop: 10}}>
              <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
              <Button style={{marginRight: 10}} onClick={this.handleResend} type='primary'>Resend</Button>
              <Button onClick={this.handleExport} type='primary'>Export</Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default SearchForm;
